module.exports = __webpack_public_path__ + "img/success-status-icon.0ca87f7d.svg";